<template>
  <div id="resolve">
    <!--  INVALID URLS | DISABLED TEMPORARY  -->
    <ex-card disable-offsets v-if="false" class="invalid_table">
      <template slot="header">
        <div class="inner">
          <h2>Invalid</h2>
        </div>
      </template>
      <template>
        <v-data-table
          :headers="invalidTableHeader"
          :items="tableDataOrigin.invalid_sellers"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
          class="ex-data-table"
        >
          <template v-slot:body>
            <tr v-for="item in tableDataOrigin.invalid_sellers" :key="item">
              <td>
                <div>
                  {{ item.seller_name }}
                </div>
              </td>
              <td>
                <table class="ex-data-table__block w-100">
                  <tr v-for="(link, linkIndex) in item.links" :key="linkIndex">
                    <td class="ex-data-table__link">{{ link }}</td>
                    <td style="width: 56px" class="ex-data-table__link">
                      <v-btn
                        text
                        class="m-w"
                        @click="deleteInValidLink(item, index, linkIndex)"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </table>
              </td>
              <td class="ex-data-table__actions">
                <v-btn
                  text
                  :ripple="false"
                  class="ma-0 mr-1 ex-btn ex-opacity-btn w-100"
                  @click="addToPermaban(item.seller_name, index)"
                >
                  Add to Permaban
                </v-btn>
                <v-btn
                  text
                  :ripple="false"
                  class="ma-0 ex-btn ex-primary-btn w-100 mt-2"
                  @click="addSeller(item, index)"
                >
                  Add Seller
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </ex-card>
    <!-- DUPLICATES CATCHED   -->
    <ex-card
      disable-offsets
      v-if="invalidUrls.duplicate_products.length"
      class="invalid_duplicate_table"
    >
      <template slot="header">
        <div class="inner">
          <h2>Invalid Duplicates</h2>
        </div>
      </template>
      <template>
        <v-data-table
          :items="invalidUrls.duplicate_products"
          :hide-default-header="true"
          item-key="product_id"
          class="ex-data-table"
        >
          <!-- <template v-slot:item="{item, index}"> -->
          <template v-slot:item="{ item }">
            <tr>
              <td class="pa-0">
                <div class="product_row_title product_name">
                  <div>
                    <span class="row_name">Product Name:</span
                    ><span class="row_name">{{
                      item.product_info.product_name
                    }}</span>
                  </div>
                  <div>
                    <v-btn
                      text
                      :ripple="false"
                      class="ma-0 ex-btn ex-primary-btn"
                      @click="goToResolve(item.product_info, item)"
                    >
                      Resolve test
                    </v-btn>
                  </div>
                </div>
                <div class="w-100 duplicated_urls">
                  <h4>Duplicated Urls</h4>
                  <div
                    class="duplicated_urls_item"
                    v-for="(domainsGroup, domainIndex) in item.product_domains"
                    :key="domainIndex"
                  >
                    <div class="duplicated_urls_item_value">
                      {{ domainsGroup.domain_urls[0].url }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </ex-card>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "Table",
  props: {
    validUrls: {
      type: [Object, Array],
      default: null,
    },
    invalidUrls: {
      type: [Object, Array],
      default: null,
    },
    addNew: {
      type: [Boolean],
      default: null,
    },
    clientsID: {
      type: [String, Number],
      default: 0,
    },
    productState: {
      type: [Object, Array],
      default: null,
    },
    selectedProductList: {
      type: [Object, Array],
      default: null,
    },
  },
  watch: {
    // 'validUrls': {
    //   handler (old, newVal) {
    //     this.tableDataOrigin = JSON.parse(JSON.stringify(newVal || old))
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  data() {
    return {
      testData: [
        { product_id: 1, product_name: "asd" },
        { product_id: 2, product_name: "qq" },
      ],
      showClearButton: false,
      variationColor: "name",
      variationSize: "",
      tableDataOrigin: {},
      errorContent: {
        error: false,
        errorMsg: "",
      },
      rowsPerPageItems: [150, 200, 300, 400],
      pagination: {
        rowsPerPage: 150,
      },
      invalidTableHeader: [
        {
          text: "Domain name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Seller link",
          sortable: false,
          value: "name",
        },
        {
          text: "Action",
          align: "left",
          sortable: false,
          value: "name",
        },
      ],
      validTableHeader: [
        {
          text: "Domain Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "URL address",
          align: "left",
          sortable: false,
          value: "name",
        },
      ],
    };
  },
  computed: {
    showButton() {
      return this.tableDataOrigin.duplicate_products;
    },
    addProductUrl: function () {
      return this.$store.state.productModule.addProductUrl;
    },
    getValidUrls() {
      this.tableDataOrigin.product_domains.domain_urls.filter((validUrl) => {
        this.tableDataOrigin.duplicate_products.find(
          (invalidUrl) => invalidUrl.product_id === validUrl
        );
      });
    },
  },
  methods: {
    selectVariationColor(sellerIndex, selectedColorId, linkIndex) {
      let obj = {
        sellerIndex: sellerIndex,
        selectedColorId: selectedColorId,
        linkIndex: linkIndex,
      };
      this.$store.commit("productModule/SET_SELECTED_COLOR_ID", obj);
    },
    selectVariationSize(sellerIndex, selectedSizerId, linkIndex) {
      let obj = {
        sellerIndex: sellerIndex,
        selectedSizeId: selectedSizerId,
        linkIndex: linkIndex,
      };
      this.$store.commit("productModule/SET_SELECTED_SIZE_ID", obj);
    },
    deleteValidLink(itemLinks, indSeller, parentIndex) {
      itemLinks.splice(Number(indSeller), 1);
      if (itemLinks.length === 0) {
        this.tableDataOrigin.valid_sellers.splice(parentIndex, 1);
      }
      this.$store.commit(
        "productModule/SET_UPDATE_VALID_SELLERS",
        this.tableDataOrigin.valid_sellers
      );
    },
    deleteInvalidDuplicateLink(index, sellerIndex, linkIndex) {
      this.tableDataOrigin.invalid_duplicate[index].sellers[
        sellerIndex
      ].links.splice(linkIndex, 1);
      if (
        this.tableDataOrigin.invalid_duplicate[index].sellers[sellerIndex].links
          .length < 1
      ) {
        this.tableDataOrigin.invalid_duplicate[index].sellers.splice(
          sellerIndex,
          1
        );
      }
      if (this.tableDataOrigin.invalid_duplicate[index].sellers.length < 1) {
        this.tableDataOrigin.invalid_duplicate.splice(index, 1);
      }
      this.$store.commit(
        "productModule/SET_UPDATE_INVALID_DUPLICATE",
        this.tableDataOrigin.invalid_duplicate
      );
      if (
        this.tableDataOrigin.invalid_duplicate.length === 0 &&
        !this.tableDataOrigin.invalid_sellers.length &&
        !this.tableDataOrigin.invalid_sellers.length
      ) {
        this.$store.commit("productModule/SET_ADD_PRODUCT_URL", false);
      }
    },
    goToResolve(productInfo, item) {
      this.$store.commit(
        "productModule/SET_CONFLICT_URL",
        item.product_domains
      );
      console.log("thisishere", item);
      this.$emit("resolveConflicts", productInfo);
      resolve.style.display = "none";
    },
    addToPermaban(sellerName, sellerIndex) {
      let obj = {
        sellerName: sellerName,
        sellerIndex: sellerIndex,
      };
      this.$store.dispatch("productModule/addToPermaban", obj);
    },
    addSeller(seller, sellerIndex) {
      let obj = {
        seller: seller,
        sellerIndex: sellerIndex,
      };
      this.$store.dispatch("productModule/addSeller", obj).then((res) => {
        console.log("77", res);
      });
    },
    deleteInValidLink(itemLinks, sellerIndex, linkIndex) {
      itemLinks.links.splice(Number(linkIndex), 1);
      if (itemLinks.links.length === 0) {
        this.tableDataOrigin.invalid_sellers.splice(sellerIndex, 1);
      }
      this.$store.commit(
        "productModule/SET_UPDATE_IN_VALID_SELLERS",
        this.tableDataOrigin.invalid_sellers
      );
    },
    extractValidSeller(sellerInfo) {
      this.$store.dispatch("productModule/extract", sellerInfo).then((res) => {
        console.log(res.data);
        [this.errorContent.error, this.errorContent.errorMsg] = [
          res.data.error,
          res.data.errorMsg,
        ];
        this.tableDataOrigin.raw_product.brand.name = res.data.product_brand;
        this.tableDataOrigin.raw_product.name.name = res.data.product_name;
        if (
          res.data.product_brand !== "" &&
          res.data.product_name !== "" &&
          this.tableDataOrigin.invalid_duplicate.length === 0 &&
          this.tableDataOrigin.invalid_sellers.length === 0
        ) {
          this.showClearButton = true;
          this.$store.commit("productModule/SET_SHOW_BUTTON", false);
        }
      });
    },
    saveRawProduct() {
      let obj = {
        product_clients: this.clientsID || [],
        product_domains: this.tableDataOrigin.product_domains,
        product_info: this.tableDataOrigin.product_info,
      };
      this.$store.dispatch("productModule/saveRawProduct", obj).then((res) => {
        this.$emit("productSaved", this.productState);
      });
    },
    clearRawProduct() {
      this.tableDataOrigin.raw_product.brand.name = "";
      this.tableDataOrigin.raw_product.name.name = "";
      this.$store.commit("productModule/SET_SHOW_BUTTON", true);
    },
  },
  mounted() {
    console.log("INVALIDS", this.invalidUrls);
    console.log(
      "state_products",
      this.$store.state.productModule.responseInvalidUrls
    );
  },
};
</script>

<style lang="scss" scoped>
.duplicated_urls {
  padding: 15px 24px;
  h4 {
    font-size: 14px;
    color: #db1430;
    font-weight: 400;
    margin-bottom: 12px;
  }
  &_item {
    &_value {
      font-size: 14px;
      color: #ccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Table.vue